// src/App.js
import "./App.css";
import React, { useRef, useState, useEffect } from "react";

import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import DoodleyDifferenceSection from "./components/DoodleyDifferenceSection";
import VetsSection from "./components/VetsSection";
import TeamSection from "./components/TeamSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AppDownloadSection from "./components/AppDownloadSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import StickyBookButton from "./components/StickyBookButton";
import WhatsAppButton from "./components/WhatsAppButton";
import whatsappicon from "./assets/whatsapp1.png";

function App() {
  const [showStickyButton, setShowStickyButton] = useState(false);
  const mainBookButtonRef = useRef(null);

  // Capture UTM parameters on initial page load
  useEffect(() => {
    const currentUrl = window.location.href;
    console.log("🔍 Current page URL:", currentUrl);

    if (!sessionStorage.getItem("url")) {
      sessionStorage.setItem("url", currentUrl);
      console.log("✅ Stored URL in sessionStorage:", currentUrl);
    } else {
      console.log(
        "📝 URL already in sessionStorage:",
        sessionStorage.getItem("url")
      );
    }
  }, []);

  useEffect(() => {
    const target = mainBookButtonRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowStickyButton(!entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0,
        rootMargin: "0px",
      }
    );

    if (target) {
      observer.observe(target);
    }

    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection mainBookButtonRef={mainBookButtonRef} />
        <ServicesSection />
        <DoodleyDifferenceSection />
        <VetsSection />
        <TeamSection />
        <TestimonialsSection />
        <AppDownloadSection />
        <FAQSection />
      </main>
      <a
        href="https://api.whatsapp.com/send?phone=919902356133&text=Hello%20Dr.Doodley%2C%20I%20need%20your%20assistance."
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          bottom: "50px",
          right: "20px",
          zIndex: 1000,
        }}
      >
        <img
          src={whatsappicon}
          alt="WhatsApp"
          style={{ width: "120px", height: "40px" }}
        />
      </a>
      <StickyBookButton isVisible={showStickyButton} />

      <Footer />
      {/* WhatsAppButton and StickyBookButton removed as requested */}
    </div>
  );
}

export default App;
